<template lang="pug">
.global-error(v-if="error")
  .error-section
    .error-content
      v-icon(color="error" size="large") mdi-alert-circle
      .error-message {{ error.message }}
    .error-actions
      v-btn(@click="refreshPage" color="white" variant="text")
        v-icon(left) mdi-refresh
        | Refresh
      v-btn(@click="copyError" color="secondary" variant="text")
        v-icon(left) mdi-content-copy
        | Copy Error
      v-btn(@click="toggleErrorDetails" color="white" variant="text" )
        v-icon(left :icon="showErrorDetails ? 'mdi-chevron-up' : 'mdi-chevron-down'")
        | {{ showErrorDetails ? 'Hide Details' : 'Show Details' }}
      v-btn(@click="clearError" color="white" variant="text" )
        v-icon(left) mdi-close
  .error-details(v-if="showErrorDetails")
      pre.error-message {{ error }}
      pre.error-message {{ error.stack }}
</template>

<script setup lang="ts">
const { $globalerror: error } = useNuxtApp()
const showErrorDetails = ref(false)
const refreshPage = () => {
  window.location.reload()
}
const props = defineProps({
  commonError: {
    type: Object || null,
  },
})

watch(
  () => props.commonError,
  (newValue, oldValue) => {
    if (newValue) {
      error.value = newValue
    }
  },
)

const copyError = () => {
  const errorText = `Error: ${error.value?.message}\nStack: ${error.value?.stack}\nError: ${error.value}`
  navigator.clipboard.writeText(errorText).then(() => {
    // You might want to show a toast or snackbar here to confirm the copy
    console.log('Error copied to clipboard')
  })
}

const toggleErrorDetails = () => {
  showErrorDetails.value = !showErrorDetails.value
}

const clearError = () => {
  error.value = null
}
</script>

<style lang="stylus" scoped>
.global-error
  position fixed
  top 0
  left 0
  right 0
  background-color var(--japanese-indigo, #194355)
  color white
  padding 16px
  z-index 9999
  animation fadeInOut 0.10s ease-in-out

  .error-section
    display flex
    justify-content space-between
    align-items center
    .error-content
      display flex
      align-items center

      .v-icon
        margin-right 12px

    .error-message
      font-weight bold
      color white

    .error-actions
      display flex
      gap 8px

    .error-details-btn
      margin-left auto
      margin-top 8px
      cursor pointer
      display flex
      align-items center
      gap 8px

  .error-details
    margin-top 8px
    background-color var(--color-secondary-light)
    color black
    padding 16px
    border-radius 4px
    .error-message
      font-weight bold
      color white


@keyframes fadeInOut
  0% {
    opacity 0
    transform: translateY(10px);
  }
  100% {
    opacity 1
    transform: translateY(0);
  }
</style>
